import {
  EmailReportUser,
  EmailReportUserCreateRequest,
  EmailReportUserUpdateRequest,
} from '../../types/app/emailReportUser.types';
import { api } from '../core/api';

export const getEmailReportUserList = (parentId: number) =>
  api
    .get<EmailReportUser[]>(`EmailReportUser/GetList?parentId=${parentId}`)
    .then((res) => res.data);

export const getEmailReportUser = (id: number) =>
  api.get<EmailReportUser>(`EmailReportUser/GetItem/?id=${id}`).then((res) => res.data);

export const updateEmailReportUser = (data: EmailReportUserUpdateRequest) =>
  api.put(`EmailReportUser/UpdateItem`, data).then((res) => res.data);

export const createEmailReportUser = (data: EmailReportUserCreateRequest) =>
  api.post(`EmailReportUser/CreateItem`, data).then((res) => res.data);

export const deleteEmailReportUser = (id: number) =>
  api.delete<EmailReportUser>(`EmailReportUser/DeleteItem/?id=${id}`).then();
